export default "__VITE_ASSET__rfU$oW_5__"